<template>
  <div class="Product">
    <div class="Product-Image">
      <images
        :images="product.image"
        :titleNext="$t('product.title_slider_next')"
        :titlePrevious="$t('product.title_slider_previous')"
      ></images>
    </div>
    <div class="Product-Details">
      <buy-box
        :is_active="(cart.length > 0) ? true : false"
      ></buy-box>

      <Cart
      v-show="cart.length > 0"
      :can_remove="true"
      :display_coupon="false"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import Images from './_partials/images.vue';
  import BuyBox from './_partials/buy-box.vue';
  import Cart from './../cart/Cart.vue';
  import GoCheckout from './_partials/go-checkout.vue';

  export default {
    props: ['module_id', 'product_id'],

    data () {
      return {
        showCart: false,
        loading: true,
        scrollParent: true
      };
    },

    components: {
      BuyBox,
      Cart,
      GoCheckout,
      Images,
    },

    watch: {
      '$route': 'fetchData'
    },

    created () {
      this.fetchData();
    },

    computed: {
      ...mapGetters([
        'product',
        'active_module',
        'cart'
      ]),

      busy () {
        return this.loading || !this.product.product_id;
      }
    },

    methods: {
      ...mapActions([
        'info_product'
      ]),

      fetchData () {
        this.loading = true;
        this.info_product({
          module_id: this.$route.params.module_id,
          product_id: this.$route.params.product_id
        }).then((resp) => {
          this.loading = false;
        });
      }
    }
  };
</script>

<style scoped>
  .Product {
    display: flex;
    flex-direction: row;
    width: 100%;
    border: 1.2px solid #D8D8D8;
  }

  .Product-Image {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 56%;
    background: #f5f5f5;
    padding-top: 2.7%;
    padding-left: 2.5%;
    padding-right: 2.5%;
    padding-bottom: .5%;

  }

  .Product-Details {
    width: 60%;
  }

  @media screen and (max-width: 767px) {
    .Product {
      flex-direction: column;
    }

    .Product-Image, .Product-Details {
      width: 100%;
    }

    .Product-Image {
      padding: 5px;
      padding-top: 1%;
      padding-bottom: 1%;
    }

    img {
      max-height: 500px;
    }
  }
</style>



// WEBPACK FOOTER //
// product-details.vue?39bd9d63